import { render, staticRenderFns } from "./moreHistory.vue?vue&type=template&id=31ceb653&scoped=true&"
import script from "./moreHistory.vue?vue&type=script&lang=js&"
export * from "./moreHistory.vue?vue&type=script&lang=js&"
import style0 from "./moreHistory.vue?vue&type=style&index=0&id=31ceb653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ceb653",
  null
  
)

export default component.exports